import client from './client';

export async function getGames(params = {}) {
  const response = await client.get('/games', { params });
  return response.data;
}

export async function createGame(data) {
  const response = await client.post('/games', data);
  return response.data;
}

export async function getGameState(gameId) {
  const response = await client.get(`/games/${gameId}`);
  return response.data;
}

export async function getGameControl(gameId) {
  const response = await client.get(`/games/${gameId}/control`);
  return response.data;
}

export async function selectBox(gameId, boxNumber) {
  const response = await client.post(`/games/${gameId}/select-box`, { box_number: boxNumber });
  return response.data;
}

export async function openBox(gameId, boxNumber) {
  const response = await client.post(`/games/${gameId}/open-box`, { box_number: boxNumber });
  return response.data;
}

export async function advanceRound(gameId) {
  const response = await client.post(`/games/${gameId}/advance-round`);
  return response.data;
}

export async function makeOffer(gameId, data = {}) {
  const response = await client.post(`/games/${gameId}/offer`, data);
  return response.data;
}

export async function respondOffer(gameId, accepted) {
  const response = await client.post(`/games/${gameId}/offer/respond`, { accepted });
  return response.data;
}

export async function completeGame(gameId, data = {}) {
  const response = await client.post(`/games/${gameId}/complete`, data);
  return response.data;
}

export async function getHistory(params = {}) {
  const response = await client.get('/games/history', { params });
  return response.data;
}
